import React from 'react';
import PropTypes from 'prop-types';
import {styled} from '@mui/material/styles';
import {makeStyles} from 'tss-react/mui';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Popover from '@mui/material/Popover';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
//ICONS
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import InputIcon from '@mui/icons-material/Input';
//DS
import {Perfil} from 'lib.front';
import {Box} from '@mui/material';

const useStyles = makeStyles()(theme => {
   return {
      root: {
         width: 'auto',
         display: 'flex',
         justifyContent: 'center'
      },
      avatar: {
         color: theme.palette.primary.contrastText,
         backgroundColor: theme.palette.primary.dark,
         cursor: 'pointer',
         margin: theme.spacing(1)
      },
      avatarBig: {
         height: '128',
         width: '128',
         marginLeft: 'auto',
         marginRight: 'auto'
      },
      popover: {
         width: '300px',
         display: 'flex'
      }
   };
});
function PerfilMenu({usuario, mapaUsuario, contenedorProps, logOut}) {
   const {classes, cx} = useStyles();
   //CONTROL DEL POPOVER
   const [anchorEl, setAnchorEl] = React.useState(null);
   const open = Boolean(anchorEl);
   const handleClick = event => {
      setAnchorEl(event.currentTarget);
   };
   const handleClose = () => {
      setAnchorEl(null);
   };
   //
   const nombre = usuario[mapaUsuario.nombre] ? usuario[mapaUsuario.nombre] : '';
   const apellido = usuario[mapaUsuario.apellido] ? usuario[mapaUsuario.apellido] : '';
   const avatarProps = {
      alt: 'Person',
      src: usuario[mapaUsuario.avatarSrc],
      children: usuario[mapaUsuario.avatarSrc]
         ? undefined
         : `${nombre.substring(0, 1).toUpperCase()}${apellido.substring(0, 1).toUpperCase()}`
   };
   return (
      <Box className={classes.root} {...contenedorProps}>
         <Avatar
            {...avatarProps}
            component="button"
            onClick={handleClick}
            className={classes.avatar}
         />
         <Popover
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
               vertical: 'bottom',
               horizontal: 'right'
            }}
            transformOrigin={{
               vertical: 'top',
               horizontal: 'right'
            }}
            className={classes.popover}
         >
            <Avatar {...avatarProps} className={cx(classes.avatar, classes.avatarBig)} />
            <Typography variant="h4" align="center">
               {`${nombre} ${apellido}`}
            </Typography>
            <Typography variant="body2" align="center">
               {usuario[mapaUsuario.titulo]}
            </Typography>

            <List>
               <Divider />
               <ListItem>
                  <ListItem button onClick={logOut}>
                     <ListItemIcon>
                        <InputIcon />
                     </ListItemIcon>
                     <ListItemText primary="Salir" />
                  </ListItem>
               </ListItem>
            </List>
         </Popover>
      </Box>
   );
}
PerfilMenu.propTypes = {
   /**
    * Informacion del usuario al que representa el perfil
    */
   usuario: PropTypes.object.isRequired,
   /**
    * Equivalencia de las propiedades usadas por el componente y las proporcionados por la propiedad `usuario`, donde:
    *
    * - `avatarSrc`: Propiedad de `usuario` que contine un link a la imagen del avatar.
    * - `nombre`: Propiedad de `usuario` que contine el nombre del usuario.
    * - `apellido`: Propiedad de `usuario` que contine el apellido del.
    * - `titulo`: Propiedad de `usuario` que contine el titulo por el cual es reconocido el usuaio.
    */
   mapaUsuario: PropTypes.shape({
      avatarSrc: PropTypes.string,
      nombre: PropTypes.string,
      apellido: PropTypes.string,
      titulo: PropTypes.string
   }),
   /**
    * Propiedades del elemento html `div` contenedor del componente.
    */
   contenedorProps: PropTypes.object
};
PerfilMenu.defaultProps = {
   mapaUsuario: {
      avatarSrc: 'avatarSrc',
      nombre: 'nombre',
      apellido: 'apellido',
      titulo: 'titulo'
   }
};

export default PerfilMenu;
